
  <div id="bg-main-id"
  
  class="background-image {{isCoBrand?'co-brand':''}} {{ApplicantLoanComponent.currentChannel?.channelName}}">

  </div>
  <router-outlet></router-outlet>


